















































































































































































































































declare var window: any;
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { countries } from '../Commons/phone-code-countries';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';

@Component({
  name: 'ProfessionalReference',
  components: {
    ProfilePlaceholder,
    AddEntity,
  },
})
export default class ProfessionalReference extends Vue {
  $moment: any;
  $wlToastr: any;
  private showForm = false;
  private selectedItem;
  private refPhone = '';
  private referenceName = '';
  private referencePhone = '';
  private referenceEmail = '';
  private title = '';
  private companyName = '';
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  private countryCode: string = '';
  private noExample: boolean = true;
  private phoneNumberValid = true;
  private errors = {
    referenceName: '',
    referencePhone: '',
    title: '',
    companyName: '',
    referenceEmail: '',
  };

  @Watch('professionalReferenceList')
  onUpdateList(newVal) {
    let minimumEntries = 0;
    const step = this.CurrentStep;
    if (step && step.meta) {
      const stepMeta = JSON.parse(step.meta);
      minimumEntries = stepMeta.minimumEntries || minimumEntries;
    }
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep
    ? newVal.length < this.minimumEntries : this.isRequiredStep) : newVal.length < minimumEntries;
    this.$emit('disable-next-button', disable);
  }

  mounted() {
    vxm.users.listProfessionalReference();
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    if('ProfessionalReference' !== this.$route.name) {
      // check only on GSU
      this.bus.$on('on-next-step', this.goToNext);
    }
  }

  goToNext() {
    this.$emit('go-to-next');
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'PROFESSIONAL_REFERENCE');
  }

  get professionalReferenceList() {
    return vxm.users.ProfessionalReferenceList;
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'PROFESSIONAL_REFERENCE',
      );
      return section ? section.displayName : 'Professional References';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'PROFESSIONAL_REFERENCE',
    );
    return section ? section.displayName : 'Professional References';
  }

  get isMyProfile() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('myprofile/v2'));
    return str.includes('myprofile/v2');
  }

  async saveProfessionalReference() {
    const vm = this;
    const isInvalid = this.validateProfessionalReferenceForm();
    if (isInvalid) {
      return;
    }

    const payload = {
      referenceName: this.referenceName,
      referencePhone: this.referencePhone,
      referenceEmail: this.referenceEmail,
      title: this.title,
      companyName: this.companyName,
      candidateProfessionalReferenceId: this.selectedItem,
    };
    if (this.selectedItem) {
      const updateRespPromise: any = vxm.users.updateProfessionalReference(
        payload,
      );
      const updateResponse = await updateRespPromise;
      if (updateResponse.success) {
        vxm.users.Rudderstack.trackEvent("Professional References Updated", {ProfessionalRefrencesData : payload})
        vm.$wlToastr(
          'success',
          vm.$t('professionalReferences-details-updated'),
          '',
        );
      } else {
        vm.$wlToastr('error', updateResponse.errorMessage, '');
      }
    } else {
      const saveRespPromise: any = vxm.users.saveProfessionalReference(payload);
      const saveResponse = await saveRespPromise;
      if (saveResponse.error) {
        vm.$wlToastr('error', saveResponse.errorMessage, '');
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('professionalReferences-details-saved'),
          '',
        );
      }
    }
    vxm.users.getProfileStrength();
    vxm.users.listProfessionalReference();
    this.showForm = false;
  }
  editProfessionalReference(id) {
    this.showForm = true;
    const selectedItem = this.professionalReferenceList.find(
      (reference) => reference.candidateProfessionalReferenceId === id,
    );
    if (!selectedItem) {
      return;
    }
    this.referenceName = selectedItem.referenceName;
    this.companyName = selectedItem.companyName;
    this.referenceEmail = selectedItem.referenceEmail;
    this.title = selectedItem.title;
    this.selectedItem = selectedItem.candidateProfessionalReferenceId;
    this.setCountryCodeAndNumber(selectedItem);
  }

  isProfessionalFieldVisible(key: string) {
    if (vxm.configs.IsConfigJSONEnabled) {
      return vxm.configs.visibilityFieldConfigValue('PROFESSIONAL_REFERENCE', 'PROFESSIONAL_REFERENCE_'+key);
    }
    return true;
  }

  setCountryCodeAndNumber(selectedItem) {
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    this.refPhone = selectedItem.referencePhone.substring(
      selectedItem.referencePhone.indexOf(' ') + 1,
    );
    let dialCode = selectedItem.referencePhone.substring(
      1,
      selectedItem.referencePhone.indexOf(' '),
    );
    for (var i = 0; i < countries.length; i++) {
      if (countries[i].dialCode === dialCode) {
        this.countryCode = countries[i].iso2;
      }
    }
  }

  async deleteProfessionalReference(id) {
    const selectedItem = this.professionalReferenceList.find(
      (reference) => reference.candidateProfessionalReferenceId === id,
    );
    if (!selectedItem) {
      return;
    }
    const selectedObj = {
      candidateProfessionalReferenceId: id,
    };
    const deleteRespPromise: any = vxm.users.deleteProfessionalReference(
      selectedObj,
    );
    const deleteResp = await deleteRespPromise;
    if (deleteResp.success) {
      vxm.users.Rudderstack.trackEvent("Professional References Deleted", {})
      this.$wlToastr(
        'success',
        this.$t('professionalReferences-details-deleted'),
        '',
      );
    } else {
      this.$wlToastr('error', deleteResp.errorMessage, '');
    }
    vxm.users.getProfileStrength();
    vxm.users.listProfessionalReference();
  }
  createNewProfessionalReference() {
    this.showForm = true;
    this.referenceName = '';
    this.referencePhone = '';
    this.referenceEmail = '';
    this.title = '';
    this.companyName = '';
    this.selectedItem = null;
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    this.refPhone = '';
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get isProfessionalReferenceSubHeaderEnabled() {
    return vxm.configs.getGlobalConfigValue('ENABLE_PROFESSIONAL_REFERENCE_SUB_HEADER')
  }

  get sectionSubHeader() {
    const section = this.CurrentStep;
    if( this.getMinimumEntries>1 && this.isConfigEnabled && this.userPermissionConfig('edit')){
      return this.$t('professionalReferences-required-step-info', {
          entries: this.getMinimumEntries,
        }).toString();
    }
    else if((!this.isConfigEnabled || (this.isConfigEnabled &&this.userPermissionConfig('edit'))) && section && section.sectionSubHeader){
     return section.sectionSubHeader
    }
    else if((!this.isConfigEnabled || (this.isConfigEnabled &&this.userPermissionConfig('edit')))){
     return this.$t('professionalReferences-required-step-info', {
          entries: this.getMinimumEntries,
        }).toString();

    }
  }
  get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }
  get getMinimumEntries() {
    let minimumEntries = 1;
    const step = this.CurrentStep;
    if (step && step.meta) {
      const stepMeta = JSON.parse(step.meta);
      minimumEntries = stepMeta.minimumEntries || minimumEntries;
    }
    return minimumEntries;
  }

  get CurrentStep() {
    return vxm.users.ProfileWizardSteps.find((step) => {
      return step.stepName === 'PROFESSIONAL_REFERENCE';
    });
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    let phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.referencePhone = phone;

    this.phoneNumberValid = event.isValid;
  }

  // formatPhone = (phoneNumber) => {
  //   phoneNumber = phoneNumber.substring(1, 14);
  //   return phoneNumber
  //     .replace(/\D+/g, '')
  //     .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  // };
  validateProfessionalReferenceForm() {
    this.errors = {
      referenceName: this.referenceName ? '' : this.$t('professionalReferences-referencename.required').toString(),
      referenceEmail: this.referenceEmail ? '' : this.$t('professionalReferences-email.required').toString(),
      title: this.title ? '' : this.$t('professionalReferences-referencetitle.required').toString(),
      companyName: this.companyName ? '' : this.$t('professionalReferences-company.required').toString(),
      referencePhone:
        !this.referencePhone || !this.phoneNumberValid
          ? this.$t('professionalReferences-valid.phone.number').toString()
          : '',
    };
    if (!this.phoneNumberValid) {
      this.errors.referencePhone = this.$t('professionalReferences-valid.phone.number').toString();
    }
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (this.referenceEmail && !this.referenceEmail.match(emailformat)) {
      this.errors.referenceEmail = this.$t('professionalReferences-valid.email').toString();
    }
    const isInvalid = Object.keys(this.errors).some((entity) => {
      return this.errors[entity];
    });
    return isInvalid;
  }
  confirmDeleteProfessionalReference(id: number) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('professionalReferences-delete'),
        body: '',
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          this.deleteProfessionalReference(id);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
}
